import {Injectable} from '@angular/core';
import {NativeDateAdapter} from '@angular/material/core';
import {MIN_YEAR, YEAR_PATTERN} from './year-only-date';

@Injectable()
export class YearOnlyDateAdapter extends NativeDateAdapter {
  override format(date: Date): string {
    if (!date) return '';
    return date.getFullYear().toString();
  }

  /**
   * NP20-950: Der NativeDateAdapter gibt jede Teileingabe an Date.parse weiter, und
   * die raet: "1" und "2" werden zu einem Monat im Jahr 2001, "200" zum Jahr 200,
   * "0" zum Jahr 2000. Beim Loeschen von "2001" lief die Eingabe deshalb ueber den
   * gueltigen Zwischenstand "2" -> 2001, den der Parent uebernahm und beim
   * Speichern zurueckschrieb. Hier zaehlt nur die vollstaendige Jahreszahl, alles
   * andere ist keine Eingabe.
   */
  override parse(value: unknown): Date | null {
    if (typeof value !== 'string') return super.parse(value);

    const raw = value.trim();
    if (!YEAR_PATTERN.test(raw)) return null;

    const year = Number(raw);
    return year >= MIN_YEAR ? new Date(year, 0, 1) : null;
  }
}
